const trimTrailingSlashes = (value: string) => value.replace(/\/+$/, '');
const runtimeOrigin =
  typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3005';
const defaultRegistryServiceURL = 'https://registry.promptlab.vernalabs.net';

const resolveDefaultRegistryServiceURL = () => {
  if (typeof window === 'undefined') {
    return defaultRegistryServiceURL;
  }

  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    return runtimeOrigin;
  }

  return defaultRegistryServiceURL;
};

// Registry service URL - points to promptlab-registry-service
export const registryServiceURL =
  trimTrailingSlashes(import.meta.env.VITE_REGISTRY_SERVICE_URL || resolveDefaultRegistryServiceURL());

export const registryApiPathPrefix = '/v1';

const configuredRouterServiceURL = trimTrailingSlashes(
  import.meta.env.VITE_ROUTER_SERVICE_URL || `${trimTrailingSlashes(registryServiceURL)}/router`,
);
const routerUrl = new URL(configuredRouterServiceURL, runtimeOrigin);
const routerPathname = trimTrailingSlashes(routerUrl.pathname);
const routerUsesRegistryGateway = routerPathname.endsWith('/router');

// Router service URL - can point either at the registry gateway (.../router) or directly
// at promptlab-router-service. The path prefix is derived accordingly.
export const routerServiceURL = routerUsesRegistryGateway
  ? configuredRouterServiceURL.replace(/\/router$/, '')
  : configuredRouterServiceURL;

export const routerApiPathPrefix = routerUsesRegistryGateway ? '/v1/router' : '/v1';
